/* ********************************************
 * intervalObserver
 * SPAのページ遷移において、前のページで設定されたインターバルをリセットする関数
 * 意図しない動作やリソースの無駄遣い（メモリリーク）を防止する目的
 * ****************************************** */
export const intervalObserver = {
  intervals: [],

  // setIntervalを追加し、IDを保存
  observerInterval(callback, interval) {
    const id = setInterval(callback, interval);
    this.intervals.push(id);
  },
  clearIntervals: function(){
    this.intervals.forEach((id) => {
      clearInterval(id);
    });
    this.intervals = [];
  },
};
